export default "__VITE_ASSET__D0Mh0On6__"